<template>
  <ModxSetlistUtility/>
</template>

<script>
import ModxSetlistUtility from './components/ModxSetlistUtility.vue'

export default {
  name: 'App',
  components: {
    ModxSetlistUtility
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
